import { useContext, useMemo } from 'react';
import { getProfileData } from '../../../api/api';
import { useApi } from '../../../hooks/use-api';
import { AuthContext } from '../../../auth/AuthContext';

/**
 * Accepts/fetches profile data and computes necessary fields for the user menu components
 */
export const useUserMenuProfile = ({ profileData, getData = false } = {}) => {
  const { user } = useContext(AuthContext) ?? {};

  const { data: fetchedProfileData } = useApi({
    requestFn: getProfileData,
    onError: (error) => {
      console.error('Your profile data has failed to load.', error);
    },
    skipInitialCall: !getData,
  });

  const profile = getData ? fetchedProfileData : profileData;

  // Name
  const name = useMemo(() => {
    let name = user?.displayName;

    if (profile?.preferredName) {
      name = [profile?.preferredName, profile?.lastName]
        .filter((x) => x)
        .join(' ');
    } else if (profile?.legalName) {
      name = profile?.legalName;
    }

    return name;
  }, [profile, user]);

  // Email
  const email = profile?.email || user?.email;

  // ID
  const id = profile?.id || user?.studentId || user?.staffId;

  // Pronouns
  const pronouns = profile?.pronouns || user?.pronouns;
  const preferredNotToSayPronouns = pronouns === 'Prefer not to say';

  return {
    name,
    email,
    id,
    pronouns: !preferredNotToSayPronouns && pronouns,
  };
};
